import React from 'react';
import './ant-radio.styl';
import Radio from 'antd/lib/radio';

class VerticalGroup extends React.Component {
	render() {
		const augmentedProps = {
			...this.props,
			className: '_vertical'
		};

		return <Radio.Group {...augmentedProps} />;
	}
}

Radio.VerticalGroup = VerticalGroup;

export default Radio;
